import { render } from "./VPAAUploadedComplianceDetails.vue?vue&type=template&id=0a07566d"
import script from "./VPAAUploadedComplianceDetails.vue?vue&type=script&lang=js"
export * from "./VPAAUploadedComplianceDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__